import React from "react";
import "react-table-v6/react-table.css";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
    Dropdown,
    Dimmer,
    Loader
} from "semantic-ui-react";
import ISMPCluster from "../../ControlPanelComponents/LatIncentives/ISMPCluster.jsx";
import SBDCluster from "../LatIncentives/SBDCluster.jsx";
import SmallChannel from "../LatIncentives/SmallChannel.jsx";
import SubdPI from "../LatIncentives/SubdPI.jsx";
import VisibilityCluster from "../LatIncentives/VisibilityCluster.jsx";
import WSCluster from "../LatIncentives/WSCluster.jsx";
import WSDisplaySupport from "../LatIncentives/WSDisplaySupport.jsx";
import SupervisoryLAT from "../LatIncentives/SupervisoryLAT.jsx";
import WSDistributorSupport from "../LatIncentives/WSDistributorSupport.jsx";
import GoldRush from "../LatIncentives/GoldRush.jsx";
import {
    fetchTemplates,
    getGoldRushDataApi,
    goldRushMappingApi,
    goldRushStartProcessApi
} from "../../../actions/users_action";

class Automation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedDisbursement:'',
            templates: [],
            selectedTemplate: '',
            templateId: ''
        };
    }

    async componentDidMount() {
        await this.props.fetchTemplates({
            onSuccess: (res) => {
                const templates = (res && res.templates) ? res.templates : [];
                if (templates.length > 0) {
                    const latest = templates[templates.length - 1];
                    this.setState({
                        templates,
                        selectedTemplate: latest.name,
                        templateId: latest._id
                    });
                } else {
                    this.setState({ templates: [], selectedTemplate: '', templateId: '' });
                }
            },
            onFailure: () => {
                this.setState({ templates: [], selectedTemplate: '', templateId: '' });
            }
        });
    }

    
    dropDownTemplateOnChange = (e, data) => {
        const selected = this.state.templates.find((t) => t.name === data.value);
        this.setState({
            selectedTemplate: data.value,
            templateId: selected ? selected._id : ''
        });
    }

    dropDownDisbursementOnChange = (e, data) => {
        this.setState({ selectedDisbursement: data.value })
    }


    render() {

        const templateMonths = this.state.templates.map((d) => ({
            key: d._id,
            value: d.name,
            text: d.name
        }));

        var disbursment_list = [
            {
                'key':'Visibility & ISMP Cluster',
                'value':'Visibility & ISMP Cluster',
                'text' : 'Visibility & ISMP Cluster'
            },
            // {
            //     'key':'ISMP Cluster Incentive',
            //     'value':'ISMP Cluster Incentive',
            //     'text' : 'ISMP Cluster Incentive'
            // },
            {
                'key':'SBD Cluster Incentive',
                'value':'SBD Cluster Incentive',
                'text' : 'SBD Cluster Incentive'
            },
            {
                'key':'WS Cluster Incentive',
                'value':'WS Cluster Incentive',
                'text' : 'WS Cluster Incentive'
            },
            {
                'key':'Small Channel Lat Incentive',
                'value':'Small Channel Lat Incentive',
                'text' : 'Small Channel Lat Incentive'
            },
            {
                'key':'SubD PI',
                'value':'SubD PI',
                'text' : 'SubD PI'
            },
            {
                'key':'Supervisory LAT',
                'value':'Supervisory LAT',
                'text' : 'Supervisory LAT'
            },
            {
                'key':'WS Distributor Support',
                'value':'WS Distributor Support',
                'text' : 'WS Distributor Support'
            },
            {
                'key':'Gold Rush',
                'value':'Gold Rush',
                'text' : 'Gold Rush'
            }

        ]


        return (
            <div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <p style={{ fontSize: 25 }}>
                        <h1
                            style={{

                                flex: "0 0 30px",
                                display: "inline-block",
                                color: "#2185d0",
                            }}
                        >
                            Disbursement LAT Automation Process
                        </h1>
                    </p>
                    <div style={{ marginLeft: 20 }}>
                        <Dropdown placeholder='Select Disbursement' search selection options={disbursment_list}
                            onChange={this.dropDownDisbursementOnChange}
                            value={this.state.selectedDisbursement}
                        />
                    </div>
                </div>
                {this.state.selectedDisbursement === 'Visibility & ISMP Cluster' && 
                <VisibilityCluster />
                }
                {this.state.selectedDisbursement === 'ISMP Cluster Incentive' && 
                <ISMPCluster />
                }
                {this.state.selectedDisbursement === 'SBD Cluster Incentive' && 
                <SBDCluster />
                }
                {this.state.selectedDisbursement === 'WS Cluster Incentive' && 
                <WSCluster />
                }
                {this.state.selectedDisbursement === 'Small Channel Lat Incentive' && 
                <SmallChannel />
                }
                {this.state.selectedDisbursement === 'SubD PI' && 
                <SubdPI />
                }
                {this.state.selectedDisbursement === 'Gold Rush' && 
                <GoldRush
                    templateId={this.state.templateId}
                    templateMonthOptions={templateMonths}
                    selectedTemplate={this.state.selectedTemplate}
                    onTemplateChange={this.dropDownTemplateOnChange}
                    getGoldRushDataApi={this.props.getGoldRushDataApi}
                    goldRushMappingApi={this.props.goldRushMappingApi}
                    goldRushStartProcessApi={this.props.goldRushStartProcessApi}
                />
                }
                {this.state.selectedDisbursement === 'WS Display Support' && 
                <WSDisplaySupport />
                }
                {
                this.state.selectedDisbursement === 'Supervisory LAT' &&
                <SupervisoryLAT />
                }
                {this.state.selectedDisbursement === 'WS Distributor Support' &&
                <WSDistributorSupport />
                }
            </div>
            

        )

    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        user: state.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            fetchTemplates,
            getGoldRushDataApi,
            goldRushMappingApi,
            goldRushStartProcessApi
        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Automation));
